import { Suspense } from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'

import App from '@/App'
import Config from '@/config'
import reportWebVitals from '@/reportWebVitals'
import LoadingLayer from './components/LoadingLayer'

import '@front/assets/fonts/fonts.css'


;(async () => {
	try {
		const response = await axios.get('/config.json')
		const config = response.data
		Config.init(config)
		ReactDOM.render(
			<Suspense fallback={<LoadingLayer />}>
				<App />
			</Suspense>,
			document.getElementById('root')
		)
	} catch (ex) {
		console.log(ex)
		ReactDOM.render(
			<App />,
			document.getElementById('root')
		)
	}
})()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
